import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { FiTrash2, FiEdit2, FiChevronDown, FiChevronUp, FiSearch } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CategoryDetails from './CategoryDetails';

const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 0.5rem;

  @media (max-width: 768px) {
    margin-left: 5px;
    padding:0px;
  }
`;

const Container = styled.div`
  padding: 4rem 2rem;
  margin-bottom: 100px;
  

  @media (max-width: 768px) {
   padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  h2 {
    color: #385963;
  }

  button {
    background-color: #385963;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
  }

  button:hover {
    background-color: #2c4a52;
  }

   @media (max-width: 768px) {
   h2{
     font-size: 13px;
   }

   button{
      font-size: 10px;
   }

  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #eee;
    color: #385963;
  }

  th {
    background-color: #f9f9f9;
  }

  td:last-child {
    text-align: right;
  }

   button {
     background: none;
     border: none;
     color: #e74c3c;
     cursor: pointer;
     font-size: 1.2rem;
   }

   button:hover {
     color: #c0392b;
   }

  @media (max-width: 768px) {
     td{
     font-size:14px;
    }   
 }
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.5rem 1rem;

  input {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    color: #385963;
  }

  svg {
    margin-right: 0.5rem;
    color: #555;
  }

  @media (max-width: 768px) {
   margin-bottom: 50px;
  }
`;

const CategoriesAdmin = ({ categoryType }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { i18n, t } = useTranslation();
  const tokenString = sessionStorage.getItem("token");
  const language = i18n.language.startsWith('gr') ? 'gr' : 'en';
  const otherLang = language === 'gr' ? 'en' : 'gr';
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const endpoint = `${BASE_URL}${categoryType}Category`;

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(endpoint);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, [endpoint]);

  const handleDelete = (id) => {
    if (!window.confirm(t('confirmDelete'))) return;

    const deleteCategory = async () => {
      try {
        const res = await fetch(`${endpoint}/${id}`, {
          method: 'DELETE',
          headers: {
            "Authorization": `Bearer ${tokenString}`,
            "Content-Type": "application/json"
          }
        });

        if (!res.ok) throw new Error('Delete failed');
        setCategories(prev => prev.filter(cat => cat.id !== id));
      } catch (error) {
        alert(t('errorDeletingCategory') || "Cannot delete this category.");
      }
    };

    deleteCategory();
  };

  const filteredCategories = categories.filter((category) => {
    const name1 = category?.name?.[language]?.toLowerCase() || '';
    const name2 = category?.name?.[otherLang]?.toLowerCase() || '';
    const term = searchTerm.toLowerCase();
    return name1.includes(term) || name2.includes(term);
  });

  return (
    <Container>
      <Header>
        <h2>{t(`${categoryType}Categories`)}</h2>
        <button onClick={() => navigate(`/admin/add-new-category/${categoryType}`)}>
          + {t('addCategory')}
        </button>
      </Header>

      <SearchBar>
        <FiSearch />
        <input
          type="text"
          placeholder={t('searchByName')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </SearchBar>

      <Table>
        <thead>
          <tr>
            <th>{t('name')}</th>
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {filteredCategories.map((cat) => (
            <React.Fragment key={cat.id}>
              <tr>
                <td>
                  {cat.name[language]}{' '}
                  <span style={{ color: '#888' }}>({cat.name[otherLang]})</span>
                </td>
                <td>
                  <ToggleButton onClick={() => setExpandedRow(expandedRow === cat.id ? null : cat.id)}>
                    {expandedRow === cat.id ? <FiChevronUp /> : <FiChevronDown />}
                  </ToggleButton>
                  <ToggleButton onClick={() => navigate(`/admin/edit-category/${categoryType}/${cat.id}`)}>
                    <FiEdit2 />
                  </ToggleButton>
                  <ToggleButton onClick={() => handleDelete(cat.id)}>
                    <FiTrash2 />
                  </ToggleButton>
                </td>
              </tr>
              {expandedRow === cat.id && (
                <tr>
                  <td colSpan="2">
                    <CategoryDetails category={cat} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default CategoriesAdmin;

















